import { Button, Col, Row, Space } from "antd";
import { Input, Select } from "components/form";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";
import { initialValues as INITIAL_VALUES } from "../schemas/whiteListSchema";

const WhiteListFilter = ({
    productCode = [],
    setProductCode,
    dropdownProduct = [],
    employeeStatusTypeOptions = [],
    onSubmit = () => { }
}) => {
    const { t, i18n } = useTranslation();

    return (
        <Formik
            initialValues={INITIAL_VALUES}
            onSubmit={(values) => {
                console.log("Submitting values:", values);
                onSubmit({
                    ...values,
                });
            }}
        >
            {({ resetForm }) => {
                return (
                    <Form>
                        <Space direction="vertical" style={{ width: "100%" }} size={24}>
                            <Row>
                                <Col span={8} style={{ paddingRight: "8px" }}>
                                    <Select
                                        name="productName"
                                        label={t("whiteList.productname")}
                                        placeholder={t('whiteList.productname')}
                                        // value={productCode}
                                        // onChange={(e) => { setProductCode(e) }}
                                        options={[{ label: i18n.language === "en" ? "All" : "ทั้งหมด", value: null }, ...dropdownProduct?.map?.(o => {
                                            return {
                                                label: o.name,
                                                value: o.productCode
                                            }
                                        })]}
                                        // className={styles.roundSelect} 

                                        size="large"
                                    />
                                </Col>
                                <Col span={8} style={{ padding: "0px 8px" }}>
                                    <Input
                                        name="employeeNo"
                                        label={t("employment-information.label.empId")}
                                        placeholder={t("employment-information.label.empId")}
                                        size="large"
                                    />
                                </Col>
                                <Col span={8} style={{ paddingLeft: "8px" }}>
                                    <Input
                                        name="name"
                                        label={t('employee.label.employee-name')}
                                        placeholder={t('employee.label.employee-name')}
                                        size="large"
                                    />
                                </Col>
                            </Row>
                            <Col span={8}>
                                <Select
                                    name="listEmployeeStatus"
                                    options={employeeStatusTypeOptions}
                                    label={t('employee.label.employee_status')}
                                    allowClear
                                    size="large"
                                    placeholder={t('employee.label.employee_status')}
                                    mode="multiple"
                                />
                            </Col>

                            <Row justify="end">
                                <Space size={12}>
                                    <Button type="default" onClick={resetForm} style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}>
                                        {t('cancel-1').toUpperCase()}
                                    </Button>
                                    <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
                                        {t("creatTamplete.Search").toUpperCase()}
                                    </Button>
                                </Space>
                            </Row>
                        </Space>
                    </Form>
                )
            }}
        </Formik>
    )
}

export default WhiteListFilter;